import { HttpMethods, makeRequest } from '../helpers/http.helper';
import { UnitRequest, UpdateUnitRequest } from '../types/unit.type';

export const getUnits = () => {
  return makeRequest({
    url: '/unit',
    method: HttpMethods.GET,
  });
};

export const getUnit = (unitId: string) => {
  return makeRequest({
    url: `/unit/${unitId}`,
    method: HttpMethods.GET,
  });
};

export const createUnit = (data: UnitRequest) => {
  return makeRequest({
    url: '/unit',
    method: HttpMethods.POST,
    data,
  });
};

export const updateUnit = (unitId: string, data: UpdateUnitRequest) => {
  return makeRequest({
    url: `/unit/${unitId}`,
    method: HttpMethods.PUT,
    data,
  });
};

export const deleteUnit = (unitId: string) => {
  return makeRequest({
    url: `/unit/${unitId}`,
    method: HttpMethods.DELETE,
  });
};
